'use strict';

var FileSaver = require('file-saver');
var dateFormat = require('dateformat');
var stringify = require('fast-json-stable-stringify');
var checkResponse = require('@itbelcom/check-response');

var log = new Log();

function timeout(value, ms) {
    var res, rej;
    var p = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });

    p._timeout = setTimeout(function() {
        //console.info('### 1: ' + (new Date().toLocaleTimeString()) + ' : ms =', ms);
        clearTimeout(p._timeout);
        p._timeout = null;
        //console.info('### 2: ' + (new Date().toLocaleTimeString()) + ' : p._timeout =', p._timeout);
        res(value());
    }, ms || 0);

    p.cancel = function(err) {
        //console.info('### 3: ' + (new Date().toLocaleTimeString()) + ' : p._timeout =', p._timeout);
        if (p._timeout) {
            rej(err || {status: -1, errorMsg: 'Timeout rejected'});
            clearTimeout(p._timeout);
            p._timeout = null;
            //console.info('### 4: ' + (new Date().toLocaleTimeString()) + ' : p._timeout =', p._timeout);
        }
        return p;
    };

    return p;
} /* timeout */



/* LogStorage **********************************************************************************************************************/
function LogStorage(o) {
    var self = this;
    var timer = null;
    var logCache = ''; // для хранения (кеширование localStorage) текущего лога
    var count = 0;  // количество записей в localStorage
    var lStorage = window.localStorage;
    var endLine = "\r\n";
    var repeatAttempts = 0;


    var options = Object.assign({
        enabled: false,                       // разрешить(запретить) накапливать лог
        appKey: '',
        logServerEnabled: false,              // разрешить отправлять лог на сервер
        logServerUrl: '',                     // 'http://xxx.xxx.xxx.xxx:port/PortalAuthServiceJson.svc/api/logapp',
        logServerInitialTimeout: 10*60*1000,  // ms; если больше нуля, то запускается сохранение по таймеру с интервалом = logServerInitialTimeout
        logServerMaxTimeout: 20*60*1000,      // ms; максимальный интервал перед повторной отправкой данных, в случае ошибки
        maxLogLength: 300,                    // bytes; максимальная длина одной записи лога (лишнее отбрасывается)
        maxStorageSize: 50000,                // bytes; максимальный размер хранилища; после заполнения переносится в буфер (текущее содержимое буфера перезаписывается) и отправляется на сервер (если разрешено)
        prefixStorage: '_log_',
        withCredentials: true
    }, o);


    self.add = add;
    self.clearAll = clearAll;
    self.saveAs = saveAs;
    self.sendToLogServer = sendToLogServer;


    init();

    /**********************************************************************************************/
    function init() {
        console.info('@itbelcom/log: LogStorage.init() 1: START');
        var errorMsg;
        if (!options.enabled) {
            return false;
        } else if (options.logServerEnabled && !options.logServerUrl) {
            errorMsg = 'Unable to save to log server as no url specified!';
        } else if (options.logServerEnabled && (typeof options.ajax !== 'function')) {
            errorMsg = '<ajax> option is not valid.';
        }

        if (errorMsg) {
            alert(errorMsg);
            throw Error(errorMsg);
        }
        // при инициализации (первоначальной загрузке), собираем информацию о логах, которые хранятся в хранилище.
        // т.е. синхронизируем текущее состояние с нашим LogStorage.
        var k = options.prefixStorage + (++count);
        var v = lStorage[k];

        while (typeof v !== 'undefined') {
            if (options.enabled) {
                logCache += v + endLine;
            } else {
                lStorage.removeItem(k);
            }
            k = options.prefixStorage + (++count);
            v = lStorage[k];
        }
        count--;

        // при инициализации (первоначальной загрузке) переносим текущие логи в буфер
        // и пытаемся соответственно отправить на сервер если это разрешено.
        moveLogToBuf();
    } /* init */


    function getBackoffDelay(attempt) {
        var R = Math.random() + 1;
        var T = options.logServerInitialTimeout;
        var F = 2;
        var N = attempt;
        var M = options.logServerMaxTimeout;

        try {
            return Math.floor(Math.min(R * T * Math.pow(F, N), M));
        } catch(e) {
            return M;
        }
    } /* getBackoffDelay */


    function clearAll() {
        clearBuf();
        clearLog();
    } /* clearAll */

    // буфер предназначен для хранения данных, когда объем данных в хранилище превысил максимально допустимый (options.maxStorageSize);
    // переполнение хранилища может произойти, когда не успели отправить данные на сервер (не успел вернуться ответ),
    // либо произошла ошибка отправки данных на сервер.
    // максимальный объем буфера так же равен options.maxStorageSize
    function clearBuf() {
        lStorage.removeItem(options.prefixStorage + 'buf');
    } /* clearBuf */


    function getBuf() {
        return lStorage[options.prefixStorage + 'buf'] || '';
    } /* getBuf */


    function addToBuf(value) {
        console.info('@itbelcom/log: LogStorage.addToBuf() 1: START');
        // сохранение данных в буфер (находится localStorage)
        // при этом буфер проверяется на переполнение и если есть переполнение,
        // то более старые логи выбрасываются (допускается трехкратное превышение текущего лога)
        value = getBuf() + value;
        var overflowLength = value.length - (3 * options.maxStorageSize);
        if (overflowLength > 0) {
            value = '[!Удалено из-за переполнения!] ' + value.substr(overflowLength);
        }
        try {
            lStorage[options.prefixStorage + 'buf'] = value;
        } catch(e) {}

        return sendToLogServerDelay(value).then(function() {
            console.info('@itbelcom/log: LogStorage.addToBuf() 2: SUCCESS');
            clearBuf();
            moveLogToBufOnTimer();
        });
    } /* addToBuf */


    function getLog() {
        return logCache;
    } /* getLog */


    function clearLog() {
        // очищаем текущий лог из localStorage(кроме буфера) и кеш
        logCache = '';
        while (count > 0) {
            lStorage.removeItem(options.prefixStorage + count--);
        }
    } /* clear */


    function add(value) {
        // добавляем лог в localStorage
        if (!options.enabled || !value) return;

        var l = value.length;
        if ((l > 0) && (l > options.maxLogLength))  {
            value = value.substr(0, options.maxLogLength - 5) + '[...]';
        }

        if (logCache.length + l > options.maxStorageSize) {
            // если размер данных в logCache превысит допустимый размер ( > options.maxStorageSize),
            // то переносим данные в буфер и если возможно/разрешено - отправляем на лог-сервер.
            moveLogToBuf();
        }

        logCache += value + endLine;
        lStorage.setItem(options.prefixStorage + (++count), value);
    } /* add */


    function timerCancel() {
        timer && timer.cancel && timer.cancel();
    } /* timerCancel */


    function saveAs(filename) {
        var blob = new Blob([getBuf() + getLog()], {type: 'text/plain;charset=utf-8'});

        filename = filename || ('log_' + dateFormat(new Date(), 'yyyy_mm_dd__HH_MM_ss_l') + '.txt');

        FileSaver.saveAs(blob, filename);
    } /* saveAs */


    function sendToLogServer(value) {
        /*
        POST http://192.168.111.178:10025/PortalAuthServiceJson.svc/api/logapp
        {"EventType":26,"Application":{"Key":"electronic_auction"},
        "Data":[{"Key":"ClientLogging","Value":"Some logging data"}]}
        */
       return options.ajax({
            method: 'POST',
            url: options.logServerUrl,
            withCredentials: options.withCredentials,
            data: {
                EventType: 26,
                Application: {
                    Key: options.appKey
                },
                Data: [{
                    Key: 'ClientLogging',
                    Value: value
                }]
            }
        }).then(checkResponse.success, checkResponse.error);
    } /* sendToLogServer */


    function sendToLogServerDelay(value) {
        // отправка данных из буфера на сервер, если это возможно/разрешено и есть данные
        console.info('@itbelcom/log: LogStorage.sendToLogServerDelay() 1: START: repeatAttempts =', repeatAttempts, '; time =', (new Date()).toLocaleString());
        timerCancel();

        if (!(options.enabled
            && options.logServerEnabled
            && options.logServerUrl))
        {
            return Promise.reject({
                status: -1,
                errorMsg: 'Запрещена отправка логов на сервер либо не указан сервер'
            });
        }

        if (!value) {
            return Promise.resolve(false);
        }

        console.info('@itbelcom/log: LogStorage.sendToLogServerDelay() 2:');
        return sendToLogServer(value).then(function(response) {
            console.info('@itbelcom/log: LogStorage.sendToLogServerDelay() 3: SUCCESS');
            repeatAttempts = 0;

            return response;
        }, function(error) {
            console.warn('@itbelcom/log: LogStorage.sendToLogServerDelay() 4: ERROR =', error);

            if (options.logServerInitialTimeout) {
                var backoffDelay = getBackoffDelay(++repeatAttempts);

                timerCancel();

                return timer = timeout(function() {
                    return sendToLogServerDelay(value);
                }, backoffDelay);
            }

            return Promise.reject(error);
        });
    } /* sendToLogServerDelay */


    function moveLogToBuf() {
        var value = getLog();
        clearLog();
        return addToBuf(value);
    } /* moveLogToBuf */


    function moveLogToBufOnTimer() {
        // перенос текущего лога в буфер, с последующей отправкой на сервер
        //console.info('@itbelcom/log: LogStorage.moveLogToBufOnTimer() 1: START');

        timerCancel();

        timer = timeout(function() {
            //console.info('@itbelcom/log: LogStorage.moveLogToBufOnTimer() 2: TIMEOUT');
            // проверяем разрешен ли таймер и нет ли предыдущей неудачной отправки
            if (options.logServerInitialTimeout && (repeatAttempts === 0)) {
                //console.info('@itbelcom/log: LogStorage.moveLogToBufOnTimer() 3: moveLogToBuf()');
                moveLogToBuf();
            }
            return moveLogToBufOnTimer();
        }, options.logServerInitialTimeout);
    } /* moveLogToBufOnTimer */
} /* LogStorage */


/* Log **************************************************************************************************************************/
function Log() {
    var self = this;
    var noop = function() {};
    var undefinedType = 'undefined';

    var options = {
        level: null,        // с какого уровня отображать логи
        showDate: false,    // отоброжать дату в логах
        showTime: true,     // отоброжать время в логах
        timeEnabled: false  // включить/отключить логирование таймингов
    };

    var levels = {
        'TRACE': 0,
        'DEBUG': 1,
        'INFO': 2,
        'WARN': 3,
        'TIMER': 3,
        'ERROR': 4,
        'SILENT': 5
    };

    var logMethods = [
        'trace',
        'debug',
        'info',
        'timer',
        'warn',
        'error'
    ];

    var formats = {
        date: 'yyyy.mm.dd',
        time: 'HH:MM:ss:l',
    };

    var timers = {};


    function bindMethod(obj, methodName) {
        //var method = obj[methodName];

        return function() {
            return toLog(methodName, Array.prototype.slice.call(arguments));
        };
    }


    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }


    function replaceLoggingMethods(level/*, loggerName*/) {
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                realMethod(methodName);//this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }


    function getDateTimeFormatted() {
        var f = '';
        if (options.showDate) {
            f = formats.date;
        }
        if (options.showTime) {
            if (f) f += ' ';
            f += formats.time;
        }
        return f ? dateFormat(new Date(), f) : '';
    }


    function data2str(s, data) {
        data = stringify(data);
        data = s + data.substring(2, data.length - 2);
        /*
        if ((size > 0) && (size < data.length))  {
            data = data.substr(0, size) + '<...>';
        }
        */
        return data;
    }


    function toLog(level, data) {
        var s = getDateTimeFormatted();
        s += (s ? ' ' : '') + '[' + level.toUpperCase() + ']' + ': ';

        if (self.storage && options.storage && (options.storage.enabled === true)) {
            var v = data2str(s, data);
            self.storage.add(v);
        }

        data.unshift(s);

        if (level === 'timer') {
            level = 'info';
        }

        console[level].apply(console, data);
    }


    self.init = function(o) {
        self.setOptions(o);
        self.storage = new LogStorage(o.storage);
    }

    self.getLevels = function() {
        return Object.assign({}, levels);
    };


    self.setOptions = function(o) {
        Object.assign(options, o);
    };


    self.setShowTime = function(val) {
        options.showTime = (val === true);
    };


    self.setShowDate = function(val) {
        options.showDate = (val === true);
    };


    self.getLevel = function() {
        return options.level;
    };


    self.setLevel = function(level) {
        if (typeof level === 'string' && levels[level.toUpperCase()] !== undefined) {
            level = levels[level.toUpperCase()];
        }
        if (typeof level === 'number' && level >= 0 && level <= levels.SILENT) {
            options.level = level;
            replaceLoggingMethods.call(self, level, name);
            if (typeof console === undefinedType && level < levels.SILENT) {
                return '@itbelcom/log: No console available for logging';
            }
        } else {
            throw '@itbelcom/log: log.setLevel() called with invalid level: ' + level;
        }
    };


    self.saveAs = function(filename) {
        self.storage  && self.storage.saveAs(filename);
    };


    self.time = function(timerName) {
        if (!options.timeEnabled) return;

        if (!timers[timerName]) {
            timers[timerName] = [];
        }
        timers[timerName].push(new Date().getTime());
    };


    self.timeEnd = function(timerName) {
        if (!options.timeEnabled) return;

        var ts = timers[timerName];
        if (!ts || !ts.length) {
            //self.warn('Timer \'' + timerName + '\' does not exist! ts =', ts);
            toLog('warn', ['Timer \'' + timerName + '\' does not exist! ts =', ts]);
            return;
        }
        ts = ts.shift();
        var t = '' + ((new Date()).getTime() - ts);
        while (t.length < 5) { t = ' ' + t }
        toLog('timer', ['[' + t + 'ms] - ' + timerName]);
    };


    self.timeProc = function(timerName, func) {
        if (!options.timeEnabled) return func();

        self.time(timerName);
        var ret = func();
        if (!ret || !ret.finally) {
            //console.info('@itbelcom/log: $$$$$$ simple timerName =', timerName);
            self.timeEnd(timerName);
            return ret;
        } else {
            return ret.finally(function() {
                //console.info('@itbelcom/log: $$$$$$ promise timerName =', timerName);
                self.timeEnd(timerName);
            });
        }
    };


    self.flush = function() {
        self.storage && self.storage.clearAll();
    }


    self.setLevel(levels.TRACE);
} /* Log */


module.exports = log;



//////////////////
// WEBPACK FOOTER
// ../node_modules/@itbelcom/log/src/index.js
// module id = 717
// module chunks = 0 1 2